import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createConversation = (title = "Nova conversa") =>
  api.post("/conversations", { title }).then((r) => r.data);

export const listConversations = () =>
  api.get("/conversations").then((r) => r.data);

export const getConversation = (id) =>
  api.get(`/conversations/${id}`).then((r) => r.data);

export const patchConversation = (id, patch) =>
  api.patch(`/conversations/${id}`, patch).then((r) => r.data);

export const deleteConversation = (id) =>
  api.delete(`/conversations/${id}`).then((r) => r.data);

export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export const getLibrary = () =>
  api.get("/library/stones").then((r) => r.data);

// Streaming chat via fetch (SSE format)
export async function streamChat({ conversationId, message, fileId, onToken, onMeta, onDone, onError }) {
  const res = await fetch(`${API}/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      conversation_id: conversationId,
      message,
      file_id: fileId || null,
    }),
  });
  if (!res.ok || !res.body) {
    onError && onError(new Error("Falha ao iniciar a conversa."));
    return;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const payload = line.slice(5).trim();
      if (!payload) continue;
      try {
        const evt = JSON.parse(payload);
        if (evt.type === "token") onToken && onToken(evt.text);
        else if (evt.type === "meta") onMeta && onMeta(evt);
        else if (evt.type === "done") onDone && onDone(evt);
        else if (evt.type === "error") onError && onError(new Error(evt.error));
      } catch (_) {
        // ignore parse errors
      }
    }
  }
}
